<template>
  <div id="app">
    <!-- 需要缓存的组件 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <!-- 不需要缓存的组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
/* 全局样式 */
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

/* 如果 #app 内还需要还需要其他布局控制 */
#app {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue